const EARNINGS_PERIODS = ["hourly", "daily", "monthly", "quarterly", "yearly"];

export function EarningsHeader({ activePeriod, setActivePeriod, activeSummary }) {
  return (
    <div className="panel-head earnings-head">
      <div>
        <span className="label">EARNINGS MONITOR</span>
        <h2 data-testid="earnings-active-period-title">{activeSummary.period.toUpperCase()} Comparison</h2>
      </div>
      <div className="period-tabs" data-testid="earnings-period-tabs">
        {EARNINGS_PERIODS.map((period) => (
          <button key={period} data-testid={`earnings-${period}-tab`} className={activePeriod === period ? "active" : ""} onClick={() => setActivePeriod(period)}>
            {period}
          </button>
        ))}
      </div>
    </div>
  );
}